import React, { type FC } from 'react';

import {
  imgixURL,
  type ImgixSource,
  type ImgixH,
  type ImgixW,
  type ImgixBG,
  type ImgixCrop,
  type ImgixFit,
  type ImgixOptions,
} from '@shared/utils/imgix';

export type PictureProps = Omit<
  React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>,
  'src'
> & {
  source?: ImgixSource;
  width: ImgixW;
  height: ImgixH;
  background?: ImgixBG;
  fit?: ImgixFit;
  crop?: ImgixCrop;
  fallback?: string;
};

const RATIOS = [
  1, // i.e. 1 × density (default)
  2, // i.e. 2 × density
  3, // i.e. 3 × density
];

export const Picture: FC<PictureProps> = ({
  source,
  width,
  height,
  background,
  fit,
  crop,
  fallback = '/missing.svg',
  ...props
}) => {
  const options: ImgixOptions = { w: width, h: height, bg: background, fit, crop };

  const src = source ? imgixURL(source, options) : fallback;
  const variants = source
    ? RATIOS.map((r) => `${imgixURL(source, { ...options, w: options.w * r, h: options.h * r })} ${r}x`).join(', ')
    : undefined;

  return <img {...props} src={src} srcSet={variants} height={height} width={width} />;
};
